import { Fragment } from "react";

import LinkTable from "@/components/ai-training/link-table/link-table";

const ActiveTrainings = () => {
    return (
        <Fragment>
            <>
                <LinkTable />
            </>
        </Fragment>
    );
};

export default ActiveTrainings;
